import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SubscriptionCheckout from '@customer/pages/subscriptions/new';
import ProductsCheckout from '@customer/pages/checkout_products/new';

export default function CustomerRoutes() {
  return (
    <Routes>
      <Route path='/customer/pages/:id/subscriptions/new' element={<SubscriptionCheckout />} />
      <Route path='/customer/pages/:id/checkout_products/new' element={<ProductsCheckout />} />
    </Routes>
  );
}
